// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__laPWH","tableColumnItem":"Table_tableColumnItem__3oUUK","tableDataItem":"Table_tableDataItem__zUNDi","tableDataWrapper":"Table_tableDataWrapper__39AHn"};